import { Entity } from '@betgames/bg-state-manager';
import { TOP_WON_AMOUNTS_CHANNEL_PREFIX } from '@bg-shared/constants/socketChannels';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import { GameId } from '@bg-shared/enums/GameId';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import HttpClientRepository, {
    httpClientRepository,
} from '@bg-shared/infrastructure/HttpClient/HttpClient.repository';
import WebSocketsRepository from '@bg-shared/infrastructure/WebSockets/WebSockets.repository';

export default class TopWonAmountsEntity extends Entity<number[], GameId> {
    constructor(
        private readonly httpClient: HttpClientRepository,
        private readonly webSockets: WebSocketsRepository,
    ) {
        super({
            key: 'TopWonAmounts',
            default: [],
        });
    }

    public initAmounts(gameId: GameId): Promise<void> {
        return this.httpClient
            .get<{ amounts: number[] }>(`${API_URLS.TOP_WON_AMOUNTS}/${gameId}`)
            .then((response) => {
                this.store(gameId).update(response ? response.amounts : []);
            });
    }

    public subscribeForUpdates(gameId: GameId): void {
        this.webSockets.on<{ amountsInEur: number[] }>(
            `${TOP_WON_AMOUNTS_CHANNEL_PREFIX}${gameId}`,
            (data) => {
                this.store(gameId).update(data.amountsInEur);
            },
        );
    }
}

export const topWonAmountsEntity = new TopWonAmountsEntity(
    httpClientRepository,
    webSocketsRepository,
);
